import { useQuery } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
export function useSolicitationInsights(projectId) {
    return useQuery({
        queryKey: [
            'solicitationInsights',
            projectId
        ],
        queryFn: ()=>proposalProjectApiConnect.getSolicitationInsights(projectId),
        staleTime: 300000,
        enabled: !!projectId,
        retry: 1
    });
}
